// extracted by mini-css-extract-plugin
export default {"file-list":"styles_file-list__rXjyv","file-item-wrapper":"styles_file-item-wrapper__Zg48p","file-list-children":"styles_file-list-children__ngHiK"};